import { useAppSelector } from "../../../app/store";
import { CaseStageEnum } from "../../../../src/api/caseStages";
import { selectCurrentCaseStage } from "../../caseinfo/logic/Slice";
import { CreatorInfoAdditionStage } from "./stages/CreatorInfoAdditionStage";
import DoAssignIoAppAuthStage from "./stages/DoAssignIoAppAuthStage";
import FrmdAdminCaseReviewStage from "./stages/FrmdAdminCaseReviewStage";
import FrmdAdminDoAssignmentStage from "./stages/FrmdAdminDoAssignmentStage";
import FrmdAdminIoAppAuthReviewStage from "./stages/FrmdAdminIoAppAuthReviewStage";
import { FwdAuthCaseReviewStage } from "./stages/FwdAuthCaseReviewStage";
import FwdAuthInformationAdditionStage from "./stages/FwdAuthInformationAdditionStage";
import IoAppAuthAssignIoStage from "./stages/IoAppAuthAssignIoStage";
import IoAssignedStage from "./stages/IoAssignedStage";
import IoSubmitIRStage from "./stages/IOSubmitIRStage";
import IoAppAuthSubmitAssessmentStage from "./stages/IOAppAuthSubmitAssessmentStage";
import PostIrAssessmentSubmittedStage from "./stages/PostIRAssessmentSubmitStage";

export const CaseStageComponent: React.FC = () => {
  const currentStage = useAppSelector(selectCurrentCaseStage);

  if(!currentStage){
    return <></>
  }

  switch (currentStage.stage) {
    case CaseStageEnum.FWD_AUTH_CASE_REVIEW:
      return <FwdAuthCaseReviewStage />;

    case CaseStageEnum.CASE_REJECTED:
      return <></>;

    case CaseStageEnum.CREATOR_INFORMATION_ADDITION:
      return <CreatorInfoAdditionStage />;

    case CaseStageEnum.FRMD_ADMIN_CASE_REVIEW:
      return <FrmdAdminCaseReviewStage />;

    case CaseStageEnum.FWD_AUTH_INFORMATION_ADDITION:
      return <FwdAuthInformationAdditionStage />;

    case CaseStageEnum.FRMD_ADMIN_DO_ASSIGNMENT:
      return <FrmdAdminDoAssignmentStage />;

    case CaseStageEnum.DO_NOMINATE_IO_APP_AUTH:
      return <DoAssignIoAppAuthStage />;

    case CaseStageEnum.FRMD_ADMIN_IO_APP_AUTH_REVIEW:
      return <FrmdAdminIoAppAuthReviewStage />;

    case CaseStageEnum.IO_APP_AUTH_ASSIGN_IO:
      return <IoAppAuthAssignIoStage />;

    case CaseStageEnum.IO_ASSIGNED:
      return <IoAssignedStage />;
    
    case CaseStageEnum.IO_SUBMIT_IR:
      return <IoSubmitIRStage />;

    case CaseStageEnum.IO_APP_AUTH_SUBMIT_ASSESSMENT:
      return <IoAppAuthSubmitAssessmentStage />;

    case CaseStageEnum.POST_IR_ASSESSMENT_SUBMITTED:
      return <PostIrAssessmentSubmittedStage />;
  
    default:
      return <></>;
  }
};
